export const individualTopInfoBarData = [
  {
    label: 'Alert ID',
    key: 'alertId'
  },
  {
    label: 'Alert Date',
    key: 'alertDate'
  },
  {
    label: 'Alert Status',
    key: 'alertStatus'
  },
  {
    label: 'Analyst Name',
    key: 'analystName'
  },
  {
    label: 'Alert Closure Reason',
    key: 'nsAlertReasonDesc'
  },
  {
    label: 'Alert Close Date',
    key: 'closureDate'
  }
];

export const individualCustomerProfile = [
  {
    label: 'Customer ID',
    key: 'primaryPartyKey'
  },

  {
    label: 'Segment',
    key: 'segmentName'
  },

  {
    label: 'Organization Unit',
    key: 'organisationUnit'
  },

  {
    label: 'Race',
    key: 'partyRace'
  },
  {
    label: 'Date of Birth',
    key: 'partyDob'
  },
  {
    label: 'Registered Address',
    key: 'customerLocation'
  },

  {
    label: 'ID Type',
    key: 'partyIdType'
  },
  {
    label: 'ID Number',
    key: 'partyIdNo'
  },
  {
    label: 'ID Country',
    key: 'partyIdCountry'
  },

  {
    label: 'Type of Business',
    key: 'partyBusinessType'
  }
];

export const individualAlertColumns = [
  {
    id: 'primaryPartyName',
    name: 'Name'
  },
  {
    id: 'partyAliases',
    name: 'Alias'
  },
  {
    id: 'customerMatchName',
    name: 'Customer Match Name/ Watchlist Match Name'
  },
  {
    id: 'relatedPartyNames',
    name: 'Related Party Names'
  },
  {
    id: 'partyGender',
    name: 'Gender'
  },
  {
    id: 'partyDob',
    name: 'Date of Birth'
  },
  {
    id: 'partyAge',
    name: 'Age'
  },
  {
    id: 'partyNationality',
    name: 'Nationality'
  },
  {
    id: 'partyBirthCountry',
    name: 'Country of Birth'
  },
  {
    id: 'partyResidenceCountry',
    name: 'Country of Residence'
  },
  {
    id: 'typeOfAlert',
    name: 'Type'
  },
  {
    id: 'past',
    name: 'Past Hits'
  }
];
//alert and hit columns should have the same order
export const individualHitColumns = [
  {
    id: 'watchlistName',
    name: 'Name'
  },
  {
    id: 'watchlistAlias',
    name: 'Alias'
  },
  {
    id: 'watchlistMatchName',
    name: 'Customer Match Name/ Watchlist Match Name'
  },
  {
    id: 'watchlistRelatedPartyNames',
    name: 'Related Party Names'
  },
  {
    id: 'watchlistGender',
    name: 'Gender'
  },
  {
    id: 'dobWatchlist',
    name: 'Date of Birth'
  },
  {
    id: 'watchlistAge',
    name: 'Age'
  },
  {
    id: 'watchlistNationality',
    name: 'Nationality'
  },
  {
    id: 'watchlistCountryOfBirth',
    name: 'Country of Birth'
  },
  {
    id: 'watchlistLocation',
    name: 'Country of Residence'
  },
  {
    id: 'typeOfHit',
    name: 'Type'
  },
  {
    id: 'pastHitsCount',
    name: 'Past Hits'
  }
];

export const individualMetrixColumns = [
  {
    id: 'hit_score',
    name: 'Hit Score'
  },
  {
    id: 'aliasScore',
    name: 'Alias Score'
  },
  {
    id: 'levensteinDistScore',
    name: 'Levenshtein Distance Score'
  },
  {
    id: 'levensteinDistScoreTokenSort',
    name: 'Levenshtein Sort Score'
  },
  {
    id: 'age_difference',
    name: 'Age Difference'
  },
  {
    id: 'min_age',
    name: 'Minimum Age'
  },
  {
    id: 'unigram_score',
    name: 'Unigram Score'
  },
  {
    id: 'bigram_score',
    name: 'Bigram Score'
  },
  {
    id: 'trigramScore',
    name: 'Trigram Score'
  },
  {
    id: 'consan_score',
    name: 'Consan Score'
  },
  {
    id: 'nonConsanScoreMax',
    name: 'Non Consan Score (MAX)'
  },
  {
    id: 'numberOfMatchingTokens',
    name: 'Number of Matching Tokens'
  },
  {
    id: 'subsetMatchSizeRatio',
    name: 'Subset Match Ratio'
  }
];

export const corperateTopInfoBarData = [
  {
    label: 'Alert ID',
    key: 'alertId'
  },
  {
    label: 'Alert Date',
    key: 'alertDate'
  },
  {
    label: 'Alert Status',
    key: 'alertStatus'
  },
  {
    label: 'Analyst Name',
    key: 'analystName'
  },
  {
    label: 'Alert Closure Reason',
    key: 'nsAlertReasonDesc'
  },
  {
    label: 'Alert Close Date',
    key: 'closureDate'
  }
];

export const corperateCustomerProfile = [
  {
    label: 'Customer ID',
    key: 'primaryPartyKey'
  },
  {
    label: 'Segment',
    key: 'segmentName'
  },
  {
    label: 'Organization Unit',
    key: 'partyOrgUnit'
  },
  {
    label: 'Country of Operation',
    key: 'countryOfIncorporation'
  },
  {
    label: 'Nature of Business',
    key: 'partyBusinessType'
  },
  {
    label: 'Registered Address',
    key: 'partyAddress'
  },
  {
    label: 'ID Type',
    key: 'partyIdType'
  },
  {
    label: 'ID Number',
    key: 'partyIdNo'
  },
  {
    label: 'ID Country',
    key: 'partyIdCountry'
  },
  {
    label: 'Buyer/Seller Name',
    key: 'buyerSellerName'
  },
  {
    label: 'Buyer/Seller Country',
    key: 'buyerSellerIncorporationCountry'
  }
];

export const corperateAlertColumns = [
  {
    id: 'primaryPartyName',
    name: 'Name'
  },
  {
    id: 'partyAliases',
    name: 'Alias'
  },
  {
    id: 'customerMatchName',
    name: 'Customer Match Name/ Watchlist Match Name'
  },
  {
    id: 'relatedPartyNames',
    name: 'Related Party Names'
  },
  {
    id: 'yearsInCorp',
    name: 'Year Of Incorporation'
  },
  {
    id: 'countryOfIncorporation',
    name: 'Country Of Incorporation'
  },
  {
    id: 'typeOfAlert',
    name: 'Type'
  },
  {
    id: 'past',
    name: 'Past Hits'
  }
];
//alert and hit columns should have the same order
export const corperateHitColumns = [
  {
    id: 'rawWatchlistName',
    name: 'Name'
  },
  {
    id: 'watchlistAlias',
    name: 'Alias'
  },
  {
    id: 'watchlistMatchName',
    name: 'Customer Match Name/ Watchlist Match Name'
  },
  {
    id: 'watchlistRelatedPartyNames',
    name: 'Related Party Names'
  },
  {
    id: 'watchlistYearOfIncorporation',
    name: 'Year Of Incorporation'
  },
  {
    id: 'watchlistCountyOfIncorporation',
    name: 'Country Of Incorporation'
  },
  {
    id: 'typeOfHit',
    name: 'Type'
  },
  {
    id: 'pastHitsCount',
    name: 'Past Hits'
  }
];

export const corperateMetrixColumns = [
  {
    id: 'hit_score',
    name: 'Hit Score'
  },
  {
    id: 'aliasScore',
    name: 'Alias Score'
  },
  {
    id: 'levensteinDistScore',
    name: 'Levenshtein Distance Score'
  },
  {
    id: 'levensteinDistScoreTokenSort',
    name: 'Levenshtein Sort Score'
  },
  {
    id: 'age_difference',
    name: 'Age Difference'
  },
  {
    id: 'min_age',
    name: 'Minimum Age'
  },
  {
    id: 'unigram_score',
    name: 'Unigram Score'
  },
  {
    id: 'bigram_score',
    name: 'Bigram Score'
  },
  {
    id: 'trigramScore',
    name: 'Trigram Score'
  },
  {
    id: 'consan_score',
    name: 'Consan Score'
  },
  {
    id: 'nonConsanScoreMax',
    name: 'Non Consan Score (MAX)'
  },
  {
    id: 'numberOfMatchingTokens',
    name: 'Number of Matching Tokens'
  },
  {
    id: 'subsetMatchSizeRatio',
    name: 'Subset Match Ratio'
  }
];

export const slateValueJson = {
  document: {
    nodes: [
      {
        object: 'block',
        type: 'paragraph',
        nodes: [
          {
            object: 'text',
            leaves: [
              {
                text: 'Put investigation details here'
              }
            ]
          }
        ]
      }
    ]
  }
};
